import PropTypes from 'prop-types';
import React from 'react';

import './ThreeColumnLayout.scss';

export default class ThreeColumnLayout extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        showLeftRailMobile: PropTypes.bool,
        rightRailContent: PropTypes.node,
        leftRailContent: PropTypes.node,
        shouldShowRightRailMobile: PropTypes.bool,
    };

    static defaultProps = {
        showLeftRailMobile: false,
        shouldShowRightRailMobile: false,
    };

    static LeftRail = ({ children }) => (
        <div className="ThreeRailLayout-LeftRail">{children}</div>
    );

    static MainContent = ({ children }) => (
        <div className="ThreeRailLayout-MainContent">{children}</div>
    );

    static RightRail = ({ children }) => (
        <div className="ThreeRailLayout-RailRail">{children}</div>
    );

    render() {
        const showRightRailCss = this.props.shouldShowRightRailMobile
            ? 'show-right-rail'
            : '';
        return (
            <div
                className={`component-Layout-ThreeColumnLayout ${showRightRailCss}`}
            >
                {this.props.children}
            </div>
        );
    }
}
